import React from "react";
import { useEffect, useState } from "react";
import Header from './Header';
import Status from './Status';
import Hero from './Hero';
import ComingSoon from "./ComingSoon";
import Current from './Current';
import Data from './Data';
import Winners from './Winners';
import Howto from './Howto';
import Footer from './Footer';

import {
  connectWallet,
  bet,
  pickWinner,
  claimPrize,
  getWeek,
  getWeekData,
  getHistory,
} from "../util/interact.js";

import { getTimestamp, waitingTime, weeks, epoch, networkDefault, networkList } from "./constants";

const Contract = ({ lotteryContract,  networkId, walletAddress, stats, symbol, amountPerBet, explorerName,
  explorerUrl, explorerAddressUrl, lotteryStarted, status, statusVisible, enabled, lastTimestamp, genesisTimestamp, setGenesis, setWallet, setStatus,
  showNotification }) => {

  const [weekNumber, setWeekNumber] = useState(-1); //default message
  const [amount, setAmount] = useState(0);
  const [nbPlayers, setNbPlayers] = useState(0);
  const [history, setHistory] = useState({});
  const [handlePick, setHandlePick] = useState(0);  
  const [handleClaim, setHandleClaim] = useState(0);  
  const [allBetAmount, setAllBetAmount] = useState(0);
  const [allWonAmount, setAllWonAmount] = useState(0);
  const [allBets, setAllBets] = useState(0);

  useEffect(() => {
    if (lotteryContract) {
      async function fetchGenesisTimestamp() {
        const genesis = await lotteryContract.methods.genesisTimestamp().call()
        setGenesis(Number(genesis));
      }
      fetchGenesisTimestamp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotteryContract]);


  useEffect(() => {

    if ((lotteryContract && lotteryStarted) || (genesisTimestamp !== 0 && lastTimestamp !== 0)) {
      
      if ((lotteryContract && lotteryStarted) || (lastTimestamp > genesisTimestamp)) {
        
        async function fetchWeekNumber() {
          const weekNumber = await getWeek(lotteryContract);
          setWeekNumber(Number(weekNumber));
        }

        async function fetchWeekData() {
          const weekData = await getWeekData(lotteryContract);
          setAmount(weekData.amount);
          setNbPlayers(Number(weekData.nbPlayers));
        }

        async function fetchHistory() {
          const obj = await getHistory(lotteryContract);
          setHistory(obj);
        }

        async function init() {
          await fetchWeekNumber();
          fetchWeekData();
          addSmartContractListener();
          fetchHistory();
        }
        init();
        
      } else {
        setWeekNumber(-1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotteryStarted, genesisTimestamp, lastTimestamp]);
  

  useEffect(() => {
    if (lotteryContract) {
      const obj = history;
      const week = parseInt(handlePick.returnValues.week);
      const winner = handlePick.returnValues.winner;
      const picker = handlePick.returnValues.picker;
      obj[week].winner = winner;
      obj[week].picker = picker;
      setHistory(obj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handlePick]);


  useEffect(() => {
    if (lotteryContract) {
      const obj = history;
      const week = parseInt(handleClaim.returnValues[0]);
      obj[week].prizeClaimed = true;
      setHistory(obj);  
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleClaim]);


  useEffect(() => {

    if (networkId && stats) {
      
      let symbolStats;

      if (networkId in networkList) {
        symbolStats = stats[networkId];
      } else {
        symbolStats = stats[networkDefault];
      }
      const allBetsTemp = symbolStats.nbBets + nbPlayers;
      const allBetAmountTemp = allBetsTemp * amountPerBet;
      const allWonAmountTemp = symbolStats.winnerAmount + symbolStats.pickerAmount;
      setAllBets(allBetsTemp);
      setAllBetAmount(allBetAmountTemp);
      setAllWonAmount(Math.floor(allWonAmountTemp*100)/100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkId, stats, nbPlayers, amountPerBet]);


  function addSmartContractListener() {
    lotteryContract.events.UpdatedLottery({}, (error, data) => {
      if (error) {
        setStatus("😥 " + error.message);
      } else {
        setAmount(data.returnValues[0]);
        setNbPlayers(Number(data.returnValues[1]));
        if (String(walletAddress).toLowerCase() === String(data.returnValues[2]).toLowerCase()) {
          showNotification(<div className="success">🎉 Your bet has been validated by the network!</div>, 3000);
        }
      }
    });

    lotteryContract.events.WinnerPicked({}, (error, data) => {
      if (error) {
        setStatus("😥 " + error.message);
      } else {
        setHandlePick(data);
      }
    });

    lotteryContract.events.ClaimedPrize({}, (error, data) => {
      if (error) {
        setStatus("😥 " + error.message);
      } else {
        setHandleClaim(data);
      }
    });
  }
  
  const connectWalletPressed = async () => {
    const walletResponse = await connectWallet();
    setWallet(walletResponse.address);
    showNotification(walletResponse.status, 3000);
  };

  const onBetPressed = async (betAmount) => {
    const { status } = await bet(lotteryContract, walletAddress, betAmount, explorerName, explorerUrl);
    showNotification(status, 5000);
  };

  async function onPickWinnerPressed(weekId) {
    if (getTimestamp() > genesisTimestamp  + (Number(weekId) + 1) * weeks + waitingTime + epoch) {
      const { status } = await pickWinner(lotteryContract, walletAddress, weekId, explorerName, explorerUrl);
      showNotification(status, 5000);  
    } else {
      showNotification(
        <div className="warning">You need to wait 10 minutes after the end of the lottery before picking a winner</div>
      , 3000)
    }
  };

  async function onClaimPrizePressed(weekId) {
    const { status } = await claimPrize(lotteryContract, walletAddress, weekId, explorerName, explorerUrl);
    showNotification(status, 5000);
  };

  return (
    <div className="Contract">
      <Header
        connectWalletPressed={connectWalletPressed}
        walletAddress={walletAddress}
        enabled={enabled}
      />
      <Status
        status={status}
        statusVisible={statusVisible}
      />
      <Hero/>
      <div className="container">
        { lastTimestamp !== 0 && lastTimestamp < genesisTimestamp
          && <ComingSoon genesisTimestamp={genesisTimestamp} />
        }
     
        { weekNumber >= 0
          && <Current
              genesisTimestamp={genesisTimestamp}
              weekNumber={weekNumber}
              amount={amount}
              nbPlayers={nbPlayers}
              symbol={symbol}
              amountPerBet={amountPerBet}
              enabled={enabled}
              walletAddress={walletAddress}
              networkId={networkId}
              onBetPressed={onBetPressed}
            />
        }

        { weekNumber >= 10
          && <Data
              allBetAmount={allBetAmount}
              allWonAmount={allWonAmount}
              allBets={allBets}
              symbol={symbol}
            />
        }

        { weekNumber > 0
          && <Winners
              enabled={enabled}
              history={history}
              walletAddress={walletAddress}
              symbol={symbol}
              amountPerBet={amountPerBet}
              explorerAddressUrl={explorerAddressUrl}
              genesisTimestamp={genesisTimestamp}
              onPickWinnerPressed={onPickWinnerPressed}
              onClaimPrizePressed={onClaimPrizePressed}
            />
        }

        <Howto/>
        <Footer/>
      </div>
    </div>
  );
}

export default Contract;
